module.exports = __webpack_public_path__ + "img/art_6_6.ba502d77.png";